const environment = process.env.REACT_APP_ENVIRONMENT;
let apiUri = process.env.REACT_APP_LOCAL_API_URL;
if (environment === "production") {
	apiUri = process.env.REACT_APP_API_URL;
}
if (environment === "development") {
	apiUri = process.env.REACT_APP_STAGING_API_URL;
}
export const apiUrl = apiUri;
